import actionCreatorFactory from 'typescript-fsa';
const actionCreator = actionCreatorFactory('skillMap');

/**
 * 分野データ
 */
export interface IDivisionData {
	/**
	 * キャリアマップID
	 */
	cmId: string;
	/**
	 * 分野ID
	 */
	fieldId: string;
	/**
	 * 言語
	 */
	lang: string;
	/**
	 * 分野名
	 */
	fieldTitle: string;
	/**
	 * 最下層分野フラグ
	 */
	isLeaf: boolean;
	/**
	 * 分野レベル
	 */
	fieldLevel: number;
	/**
	 * 親分野ID
	 */
	parentFieldId: string | null;
	/**
	 * 下階層数
	 */
	countOfSubject: number;
	/**
	 * 表示順
	 */
	displayOrder: number;
	/**
	 * 分野ID1
	 */
	fieldId1: number;
	/**
	 * 分野ID2
	 */
	fieldId2: number;
	/**
	 * 分野ID3
	 */
	fieldId3: number;
	/**
	 * 分野ブロック数
	 */
	count: number;
}

/**
 * レベルデータ
 */
export interface ILevelData {
	/**
	 * キャリアマップID
	 */
	cmId: string;
	/**
	 * キャリアマップセルID
	 */
	cmcId: string;
	/**
	 * 分野ID
	 */
	fieldId: string;
	/**
	 * レベルID
	 */
	levelId: string;
	/**
	 * レベル名
	 */
	levelTitle: string;
	/**
	 * 言語
	 */
	lang: string;
	/**
	 * 説明
	 */
	contents: string;
	/**
	 * ステータス
	 */
	status: number;
	/**
	 * 目標種別
	 */
	targetType: number;
	/**
	 * コメント
	 */
	comment: string;
}

/**
 * 画面表示用マスタデータ
 */
export interface IMasterInfo {
	/**
	 * 短期目標アイコン背景色
	 */
	shortGoalColor: string;
	/**
	 * 長期目標アイコン背景色
	 */
	longGoalColor: string;
	/**
	 * 目標達成セル背景色
	 */
	goalCompleteColor: string;
	/**
	 * 分野１の背景色
	 */
	division1Color: string;
	/**
	 * 分野２の背景色
	 */
	division2Color: string;
	/**
	 * 分野３の背景色
	 */
	division3Color: string;
}

/**
 * 最後更新情報
 */
export interface IUpdateInfo {
	/**
	 * スキルマップ名
	 */
	skillMapName: string;
	/**
	 * 最終更新ユーザ名
	 */
	updator: string;
	/**
	 * 最終更新日時
	 */
	updateTime: string;
}

/**
 * 目標設定更新用パラメータ
 */
export interface ITargetSetParam {
	/**
	 * キャリアマップID
	 */
	cmId: string;
	/**
	 * キャリアマップセルID
	 */
	cmcId: string;
	/**
	 * 目標種別
	 */
	target: number;
	/**
	 * レベル目標設定時のラベル(【セルを従属する分野の名称】レベル)
	 */
	cellLabel: string;
	/**
	 * コメント
	 */
	comment: string;
	/**
	 * ユーザID
	 */
	userId: string;

	/**
	 * 管理者
	 */
	adminView: boolean;
}

/**
 * スキルマップデータ
 */
export interface ISkillMapData {
	/**
	 * 分野データ
	 */
	divisionData: IDivisionData[];
	/**
	 * レベルデータ
	 */
	levelData: ILevelData[];
	/**
	 *
	 */
	rootDivision: any[];
	/**
	 * マスタデータ
	 */
	masterData: IMasterInfo;
	/**
	 * 最後操作情報
	 */
	updateInfo: IUpdateInfo;

	/**
	 * 利用フラグ
	 */
	applyFlg: number;
}

/**
 * セル詳細データ検索条件
 */
export interface IFetchJoken {
	/**
	 * キャリアマップID
	 */
	cmId: string;
	/**
	 * キャリアマップセルID
	 */
	cmcId: string;
	/**
	 * ユーザID
	 */
	userId?: string;
}

/**
 * 更新履歴取得検索条件
 */
export interface IFetchHistoryJoken {
	/**
	 * キャリアマップID
	 */
	cmId: string;
	/**
	 * ユーザID
	 */
	userId?: string;
}

/**
 * セル詳細データ
 */
export interface IDetailData {
	/**
	 * 認定優先フラグ
	 */
	isPriority: string;
	/**
	 * キャリア名
	 */
	careerTitle: string;
	/**
	 * キャリア種別名
	 */
	careerType: string;
	/**
	 * キャリア種別ID
	 */
	careerTypeID: string;
	/**
	 * ステータス
	 */
	status: string;
	/**
	 * キャリアID
	 */
	careerID: string;
	/**
	 * ランク名
	 */
	rankName: string;
	/**
	 * ステータスID
	 */
	statusId: string;

	/**
	 * ステータス（数値）
	 */
	statusNum: number;
}

/**
 * 更新履歴画面データ
 */
export interface ISkillMapHistory {
	/**
	 * 更新日時
	 */
	updateTime: string;
	/**
	 * 操作
	 */
	action: string;
	/**
	 * コメント
	 */
	comment: string;
	/**
	 * 実施者
	 */
	updator: string;
}

/**
 * スキルマップデータ設定
 */
export const setSkillMapData = actionCreator<ISkillMapData>(
	'SET_SKILL_MAP_DATA'
);

/**
 * セル詳細データ設定
 */
export const setDetailData = actionCreator<IDetailData[]>('SET_DETAIL_DATA');

/**
 * 更新履歴画面データ設定
 */
export const setHistoryData = actionCreator<ISkillMapHistory[]>(
	'SET_SKILL_HISTORY_DATA'
);

/**
 * 最後更新情報データ設定
 */
export const setLastUpdateData = actionCreator<IUpdateInfo>(
	'SET_LAST_UPDATE_DATA'
);



// WEBPACK FOOTER //
// ./src/actions/skillMap.ts